export const ORG_DETAIL_TOP_TABS = [
  'members',
  'plan_requests',
  'care_programs',
  'payment_advice',
  'export',
];

export const MEMBERS_SECTIONS = ['active', 'inactive', 'onboarding', 'uploads'];

/** Policies API tab for pending onboarding (`user_data.status = 0`). */
export const PENDING_ONBOARDING_POLICY_TAB = 'pending_onboarding';

/**
 * Canonical pending-onboarding count for KPIs and badges.
 * Prefer `tabs.pending_onboarding` — never label bulk_uploaded as pending (§8.1a).
 */
export function getPendingOnboardingCount(tabCounts = {}) {
  const pending = tabCounts?.pending_onboarding?.count;
  if (pending != null && pending !== '') return Number(pending) || 0;
  const activation = tabCounts?.pending_activation?.count;
  if (activation != null && activation !== '') return Number(activation) || 0;
  return 0;
}

/** Legacy top-level tab keys that now live under Members. */
export const LEGACY_MEMBER_TAB_KEYS = [
  'active',
  'inactive',
  'bulk_uploaded',
  'pending_onboarding',
  'staff_uploads',
  'upload_history',
];

const LEGACY_TAB_TO_SECTION = {
  active: 'active',
  inactive: 'inactive',
  bulk_uploaded: 'onboarding',
  pending_onboarding: 'onboarding',
  staff_uploads: 'uploads',
  upload_history: 'uploads',
};

export function membersSectionToPolicyTab(section) {
  if (section === 'onboarding') return PENDING_ONBOARDING_POLICY_TAB;
  if (section === 'active' || section === 'inactive') return section;
  return null;
}

function normalizeMembersSection(section) {
  return MEMBERS_SECTIONS.includes(section) ? section : 'active';
}

/**
 * Resolve org detail route from URL search params.
 * @returns {{ tab: string, section: string|null, params: Record<string,string>, needsRedirect: boolean }}
 */
export function resolveOrgDetailRoute(searchParams) {
  const tab = searchParams.get('tab');
  const section = searchParams.get('section');

  if (tab && LEGACY_TAB_TO_SECTION[tab]) {
    const mappedSection = normalizeMembersSection(LEGACY_TAB_TO_SECTION[tab]);
    return {
      tab: 'members',
      section: mappedSection,
      params: { tab: 'members', section: mappedSection },
      needsRedirect: true,
    };
  }

  if (tab === 'members') {
    const mappedSection = normalizeMembersSection(section);
    const needsRedirect = !MEMBERS_SECTIONS.includes(section);
    return {
      tab: 'members',
      section: mappedSection,
      params: { tab: 'members', section: mappedSection },
      needsRedirect,
    };
  }

  if (ORG_DETAIL_TOP_TABS.includes(tab)) {
    return {
      tab,
      section: null,
      params: { tab },
      needsRedirect: false,
    };
  }

  if (!tab) {
    return {
      tab: 'members',
      section: 'active',
      params: { tab: 'members', section: 'active' },
      needsRedirect: false,
    };
  }

  return {
    tab: 'members',
    section: 'active',
    params: { tab: 'members', section: 'active' },
    needsRedirect: true,
  };
}
